document.addEventListener('DOMContentLoaded', function () {
  const noshCheckbox = document.getElementById('nosh-checkbox');
  const noshDropdown = document.getElementById('nosh-dropdown');
  const noshDropdownContainer = document.getElementById('nosh-dropdown-container');

  if (noshCheckbox && noshDropdown && noshDropdownContainer) {
    noshCheckbox.addEventListener('change', function () {
      if (noshCheckbox.checked) {
        noshDropdownContainer.style.display = 'block';
      } else {
        noshDropdownContainer.style.display = 'none';
        noshDropdown.value = '';
      }
    });
  }
});
